import { ButtonLink } from '@asgard/ui-library';
import { faCloudDownload } from '@fortawesome/pro-light-svg-icons';
import { faCloudDownload as faCloudDownloadSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHeader,
  StyledWrapper
} from './ConsultancyCta.styled';

const ConsultancyCta: React.FC = () => {
  const { t } = useI18n('consultancy');
  const { locale } = useRouter();

  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHeader>
          <FontAwesomeIcon icon={faCloudDownload} />
          <div>
            <Heading2 editorial>{t('consultancy.cta.title')}</Heading2>
            <p>{t('consultancy.cta.desc')}</p>
          </div>
          <ButtonLink
            href={
              locale === 'es'
                ? getPublicPath('/files/manfred-consulting-deck-ES.pdf')
                : getPublicPath('/files/manfred-consulting-deck-EN.pdf')
            }
            schema="brand1"
            variant="hard"
            startIcon={faCloudDownloadSolid}
            label={t('consultancy.cta.cta')}
            download
          />
        </StyledHeader>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default ConsultancyCta;
